import {SearchAlertConstant} from "../redux_constants/search.constant";
import {urlEncoder} from "../redux_actions/slides.action";

export const getNewState = () => {
    return {
        isFetching: true,
        tags: [],
        searches: [],
		filters: [],
        ordering: "-date_time",
        page: 1,
        numPages: 1,
        count: 1,
        defaultOrderUsed: false
    }
}

const InitialState = getNewState();

export const searchReducer = ( state = InitialState , action) => {
    var returnableState = {}
    switch(action.type){
        case SearchAlertConstant.SEARCH_INITIATED:
            returnableState = {
                ...state,
                isFetching : true,
            }
            return returnableState;
        case SearchAlertConstant.TOGGLE_ORDER_USED:
            returnableState = {
                ...state,
                defaultOrderUsed: action.defaultOrderUsed,
            }
            return returnableState;
        case SearchAlertConstant.SEARCH_SUCCESS:
            returnableState = {
                ...state,
                isFetching : false,
            }
            return returnableState;
        case SearchAlertConstant.SEARCH_FAILED:
            returnableState = {
                ...state,
                err: action.error,
                isFetching: false,
            }
            return returnableState;
        case SearchAlertConstant.UPDATE_URL_STATE:
            returnableState = Object.assign({}, action.urlState);
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertConstant.UPDATE_SEARCHES:
            returnableState = {
                ...state,
            }
            returnableState.searches = action.searches;
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertConstant.UPDATE_TAGS:
            returnableState = {
                ...state,
            }
            returnableState.tags = action.tags;
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertConstant.UPDATE_FILTERS:
            returnableState = {
                ...state,
            }
            returnableState.filters = action.filters;
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertConstant.CHANGE_PAGE:
            returnableState = {
                ...state
            }
            returnableState.page = action.page
            updateUrl(returnableState);
            return returnableState;
        default :
            returnableState = state
            return returnableState;
    }
}

export const updateUrl = (state) => {
    var encodedUrl = urlEncoder(state);
    window.history.replaceState(state, 'filter_params', encodedUrl);
}